/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React, { useEffect, useState } from 'react';
import { RequestToJoinForm } from '../partials/RequestToJoinForm';
import { BaseStepCompProps, OnboardingMatches } from '../types';
import { useAppSelector } from '../../../reducers';
import { getCurrentUser } from '../../../selectors/user';
import G17Client from '../../../services/G17Client';
import { BlockingLoader } from '../../loader/BlockingLoader';
import { RequestSent } from '../partials/RequestSent';

export interface EmailDomainCompanyOnboardOrNotProps extends BaseStepCompProps {
}

export const EmailDomainCompanyOnboardOrNot = (props: EmailDomainCompanyOnboardOrNotProps) => {
  const { appConfig, goToStep, handleNext } = props;

  const currentUser = useAppSelector(getCurrentUser);
  const onboardingPath = appConfig.onboardingPath;

  const [isLoaded, setLoaded] = useState(false);
  const [matches, setMatches] = useState<OnboardingMatches[]>([]);
  const [invitations, setInvitations] = useState<OnboardingMatches[]>([]);

  useEffect(() => {
    if (!currentUser?.active) {
      // Accessing this page without being active, so send them to the start in order to figure out where to go
      goToStep();
    } else {
      const hasInitiatives = currentUser.permissions.length > 0;
      if (hasInitiatives) {
        handleNext();
      }
    }
  }, [currentUser, goToStep, handleNext]);

  useEffect(() => {
    if (!currentUser) {
      return;
    }
    Promise.all([
      G17Client.getInvitations(onboardingPath).then(initiatives => setInvitations(initiatives)),
      G17Client.getCompaniesByUserEmail(onboardingPath).then(initiatives => setMatches(initiatives))
    ]).finally(() => setLoaded(true));

  }, [currentUser, onboardingPath]);

  if (!isLoaded) {
    return <BlockingLoader />;
  }

  if (invitations.length > 0) {
    return <RequestSent appConfig={appConfig} requests={invitations} />;
  }

  if (matches.length > 0) {
    return <RequestToJoinForm {...props} initiatives={matches} />;
  }

  handleNext();
  return <BlockingLoader />;
}
